import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export const AsyncAddReportToDashboardDialog = Loadable({
  loader: () => /* webpackChunkName: "reporting-action-components-modals" */import(
  // @ts-expect-error untyped module
  './AddReportToDashboardDialog'),
  LoadingComponent: () => null
});